module.exports = __webpack_public_path__ + "static/media/menu_dark_gray.b939b2b5.png";


/*****************
 ** WEBPACK FOOTER
 ** ./media/menu_dark_gray.png
 ** module id = 258
 ** module chunks = 0
 **/